<template>
    <svg width="42" height="28" viewBox="0 0 42 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M33 7.5V2L2 12.4151V17.905C2 21.3626 5.42546 23.7766 8.68168 22.6137L9 22.5" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
        <path d="M39.6816 4.05182C39.9867 3.94942 40.3227 4.00072 40.584 4.18854C40.8451 4.37643 41 4.67837 41 5.00006V11.0001C41 11.5523 40.5523 12.0001 40 12.0001C39.4477 12.0001 39 11.5523 39 11.0001V6.39166L10 16.1348V20.67C10.0001 23.4879 12.8363 25.422 15.46 24.3936L27.9695 19.4899C28.5179 19.275 29.1309 19.587 29.2798 20.1569C29.4055 20.6381 29.1521 21.1374 28.6895 21.32L16.1895 26.2559C12.254 27.7984 8.00009 24.8969 8 20.67V15.4151C8.00006 14.9856 8.27449 14.6036 8.68164 14.4669L39.6816 4.05182Z" fill="currentColor"/>
        <path d="M39.3743 14.2789C39.7462 13.907 40.3491 13.907 40.721 14.2789C41.093 14.6509 41.093 15.2538 40.721 15.6257L37.3467 19L40.721 22.3743C41.093 22.7462 41.093 23.3491 40.721 23.721C40.3491 24.093 39.7462 24.093 39.3743 23.721L36 20.3467L32.6257 23.721C32.2538 24.093 31.6509 24.093 31.2789 23.721C30.907 23.3491 30.907 22.7462 31.2789 22.3743L34.6533 19L31.2789 15.6257C30.907 15.2538 30.907 14.6509 31.2789 14.2789C31.6509 13.907 32.2538 13.907 32.6257 14.2789L36 17.6533L39.3743 14.2789Z" fill="currentColor"/>
    </svg>
</template>

<script>
export default {
    name: 'SVGSeparatorsRm',
};
</script>

<style scoped lang="scss">

</style>
